import { Link } from "react-router-dom";
import styles from "./WhatsappDefaultConfig.module.css";

const WhatsappDefaultConfig = () => {
  return (
    <div className={styles.whatsappDefaultContainer}>
      <div className={styles.whatsappHeader}>
        <img
          src="/assets/img/whatsapp-illustration.png"
          alt="WhatsApp Automation"
          className={styles.whatsappIllustration}
        />
        <div>
          <h3>Enable WhatsApp Automation</h3>
          <p className={styles.whatsappDescription}>
            Send automated WhatsApp messages to your employees and customers.
            You can notify them about updates, confirmations, alerts, and more –
            all through approved WhatsApp templates.
          </p>
          <ul className={styles.whatsappFeatures}>
            <li>✅ Send messages to users automatically</li>
            <li>✅ Create reusable message templates</li>
            <li>✅ Reduce manual communication workload</li>
            <li>✅ Engage customers on their preferred platform</li>
          </ul>
          <Link to="/configuration/fonada" className={styles.btnPrimary}>
            Activate Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default WhatsappDefaultConfig;
